// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1_QZc","cls2":"NewsInteractionBar-cls2_RH9 NewsInteractionBar-cls1_QZc","variant-dense":"NewsInteractionBar-variant-dense_D16"};